import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles((theme: any) => ({
   imageWrap: {
       width: '100px',
       height: '100px',
       position: "relative",
       display: "flex",
       alignItems: 'center',
       justifyContent: 'center',
       margin: '5px',
       border: `1px solid ${theme.palette.divider}`,
       borderRadius: '4px',
       overflow: 'hidden',
       '& img': {
           maxWidth: '100%',
           maxHeight: '100%',
           objectFit: 'cover'
       },
       '&:hover $deleteButton': {
           display: 'block'
       }
   },
   imagesContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px'
   },
   popUpWrapper: {
       width: '100%',
       height: '100%',
       position: "fixed",
       display: "flex",
       alignItems: "center",
       justifyContent: "center",
       backgroundColor: "#808080c2",
       top: 0,
       left: 0,
       zIndex: 20,
   },
    popUp: {
        maxWidth: '600px',
        maxHeight: '600px',
        backgroundColor: theme.palette.background.paper,
        padding: '40px 50px',
        borderRadius: '20px'
    },
    popUpImage:{
       width: '100%',
       maxHeight: '600px',
        marginBottom: '40px',
       '& img': {
           display: "block",
           maxWidth: '100%',
           maxHeight: '400px',
           margin: '0 auto',
       }
    },
    buttonsWrap: {
       display: "flex",
        minWidth: '450px',
        justifyContent: 'space-around'
    },
    blockWrap: {
        padding: '20px 15px 15px',
        margin: 8,
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: '4px',
        position: "relative",
    },
    blockLabel: {
        position: 'absolute',
        top: '-12px',
        left: '20px',
        padding: '0 5px',
        backgroundColor: theme.palette.background.paper,
        fontSize: '1rem',
        color: theme.palette.text.secondary,
    },
    deleteButton: {
        display: 'none',
        position: 'absolute',
        top: '2px',
        right: '2px',
        backgroundColor: 'rgba(255,255,255,0.8)',
        borderRadius: '50%',
        padding: '2px',
        cursor: 'pointer',
        color: 'red'
    },
    addButton: {
        width: '100px',
        height: '100px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `2px dashed ${theme.palette.primary.main}`,
        borderRadius: '4px',
        cursor: 'pointer',
        color: theme.palette.primary.main,
        margin: '5px',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        }
    },
    popUpLoader: {
        width: '100%',
        height: '100%',
        backgroundColor: '#80808080',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 100,
        display: "flex",
        justifyContent: 'center',
        alignItems: "center",
        borderRadius: '20px',
    }
}));
